var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomModule10(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.89998 19.1H10.9V20.9H4.99998C4.49606 20.9 4.01279 20.6998 3.65647 20.3435C3.30015 19.9872 3.09998 19.5039 3.09998 19V4.99998C3.09998 3.9452 3.9452 3.09998 4.99998 3.09998H14.9586L20.9 9.0414V9.91065C20.3042 9.98677 19.7554 10.2331 19.3193 10.6693L18.0886 11.9H12.1V4.89998H4.89998V19.1ZM19.7414 10.1L13.9 4.25855V10.1H19.7414ZM22.7811 14.1175L22.7793 14.1193L21.87 15.0286L19.9714 13.13L20.8807 12.2207L20.8825 12.2189C21.0321 12.0614 21.2973 12.0587 21.4593 12.2207L22.7793 13.5407C22.9412 13.7027 22.9386 13.9679 22.7811 14.1175ZM13.1 21.9V20.0014L19.13 13.9714L21.0286 15.87L14.9986 21.9H13.1Z",
    fill: "#192048"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomModule10);
export default __webpack_public_path__ + "static/media/CustomModule10.e23b843320c654dc4dba4d85f082982e.svg";
export { ForwardRef as ReactComponent };